"use client";

import { type SignInOptions, signIn } from "next-auth/react";
import Iconify from "~/components/iconify";
import { Button } from "~/shadcn/ui/button";
import { Separator } from "~/shadcn/ui/separator";

// ----------------------------------------------------------------------

type Props = {
  dict: Dictionary;
  showSeparator?: boolean;
};

export default function AuthWithSocial({ dict, showSeparator = true }: Props) {
  const handleProviderLogin = async (
    provider: "google" | "google-admin",
    options?: SignInOptions,
  ) => {
    try {
      return await signIn(provider, options ?? {});
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="mt-1 flex flex-col gap-3">
      {showSeparator && (
        <div className="my-3 flex items-center justify-center space-x-4">
          <Separator className="flex-1" />
          <p className="text-center text-secondary-foreground text-sm">
            {dict["Logga in med"]}
          </p>
          <Separator className="flex-1" />
        </div>
      )}

      <div className="flex flex-col items-center gap-2">
        <Button
          className="h-12 w-full text-base"
          size="lg"
          variant="outline"
          onClick={() => handleProviderLogin("google")}
        >
          <Iconify icon="logos:google" className="h-5 w-5" color="#DF3E30" />
          <span className="ml-2">Google</span>
        </Button>
      </div>
    </div>
  );
}
